import script from "./cpt-realtime-position-option.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-realtime-position-option.vue?vue&type=script&setup=true&lang=js"

import "./cpt-realtime-position-option.vue?vue&type=style&index=0&id=6ce48010&lang=css"

const __exports__ = script;

export default __exports__